export default {"src":"/_next/static/media/pytorch.7c4e25e8.svg","height":310,"width":256,"blurWidth":0,"blurHeight":0};